import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(vendorCode) {
  return `v1/stock/market_index/detail/${vendorCode}/price/`;
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);
      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {string} vendorCode
 */
export default function fetch(vendorCode) {
  const code = (vendorCode || '').toUpperCase();
  const url = getUrl(code);
  const cb = callbackFetch(url);
  const key = [url];

  return { cb, key };
}
